module.exports = __webpack_public_path__ + "assets/img/faspay_716.c648b31d.png";